import { useRoute, useRouter } from 'vue-router';
import { useAccount } from 'dashboard/composables/useAccount';

export const GLOBAL_SEARCH_FOCUS_EVENT = 'wacord:focus-global-search';

export const inferSearchTabFromRoute = routeName => {
  if (!routeName) return 'all';
  if (
    routeName === 'web_order_orders' ||
    routeName.startsWith('web_order_order')
  ) {
    return 'orders';
  }
  if (routeName.startsWith('web_order_customer')) return 'web_customers';
  if (
    routeName === 'inventory_products' ||
    routeName === 'inventory_product_new' ||
    routeName === 'inventory_product_detail' ||
    routeName === 'web_order_products'
  ) {
    return 'web_products';
  }
  if (routeName.startsWith('web_order')) return 'orders';
  return 'all';
};

export const useGlobalSearch = () => {
  const router = useRouter();
  const route = useRoute();
  const { accountId } = useAccount();

  const openGlobalSearch = ({ tab = 'all', q = '' } = {}) => {
    if (route.name === 'search') {
      window.dispatchEvent(new CustomEvent(GLOBAL_SEARCH_FOCUS_EVENT));
      return;
    }

    router.push({
      name: 'search',
      params: {
        accountId: accountId.value,
        ...(tab && tab !== 'all' ? { tab } : {}),
      },
      query: {
        ...(q?.trim() ? { q: q.trim() } : {}),
      },
    });
  };

  const openGlobalSearchFromRoute = (options = {}) => {
    openGlobalSearch({
      tab: inferSearchTabFromRoute(route.name),
      ...options,
    });
  };

  return {
    openGlobalSearch,
    openGlobalSearchFromRoute,
    inferSearchTabFromRoute,
  };
};
